import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';

import { DataCollectionStateInterface } from '../interfaces/data-collection-state.interface';
import { DataCollectionInterface } from '../interfaces/data-collection.interface';

import { ResetState } from './actions/reset-state';

const DEFAULT_STATE_DATA: DataCollectionStateInterface = {
    dataCollection: null,
    inspections: [],
};

@State<DataCollectionStateInterface>({
    name: 'datacollection',
    defaults: DEFAULT_STATE_DATA,
})
@Injectable()
export class DataCollectionState {
    @Selector()
    public static dataCollection$(state: DataCollectionStateInterface): DataCollectionInterface | null {
        return state.dataCollection;
    }

    /** @deprecated */
    @Selector()
    public static inspections$(state: DataCollectionStateInterface): Array<DataCollectionInterface> {
        return state.inspections || [];
    }

    @Action(ResetState)
    public resetState(stateContext: StateContext<DataCollectionStateInterface>): void {
        stateContext.setState(DEFAULT_STATE_DATA);
    }
}
